<template>
  <div class="us-faq">
    <faq-section :questions="questions" :padding="30"/>
  </div>
</template>

<script>
import FaqSection from '../../shared/components/FaqSection.vue';

const QUESTIONS = {
  default: [
    {
      question: `Why Is Unranked Smurfs The Best Place To Buy LoL Accounts?`,
      answer: `Unranked Smurfs is the best place to buy a LoL account with secure website and range of payment options, including SSL encryption and full payment security. Don’t believe us? Just check out or thousands of 5-star reviews on the independent review platform <a href="https://www.reviews.io/company-reviews/store/unranked-smurfs" target="_blank" >Reviews.io</a >.`,
    },
    {
      question: `What Is Your Lifetime Warranty?`,
      answer: `Each LoL account offers a free lifetime warranty. If your account happens to get a ban or get locked, we will help you recover it or provide you with a new account. The warranty for our LoL accounts depends on your behavior in game - it covers only bans due to flawed accounts.`,
    },
    {
      question: `Can I Change The Account Details?`,
      answer: `Yes! Each unranked account comes with login details so you can log in to your account and change anything you like. We even provide a step by step guide on how to do it!`,
    },
    {
      question: `What Payment Methods Do You Accept?`,
      answer: `We accept anumber of different payment options including some of the world's most trusted payment platforms & processors. Your details are securely processed and are never stored by Unranked Smurfs or anythird party. It's a safe buying process.`,
    },
    {
      question: `How Fast Will I Get My Account?`,
      answer: `As soon as you confirm your order and send payment you’ll receive your account in a matter of minutes. All details will immediately be shown on thescreen and a copy will be sent to your email address. With our systems working 24/7 you’ll instantly receive your account no matter where you are.`,
    },
    {
      question: `How Can I Send You A Message?`,
      answer: `If you have a problem with your account and need some support then feel free to contact us via <a href="https://www.facebook.com/UnrankedSmurfs/">Facebook</a>, <a href="https://twitter.com/unrankedsmurfs">Twitter</a>, Skype or send us an email at <a href="mailto:support@UnrankedSmurfs.com">support@UnrankedSmurfs.com</a>`,
    },
    {
      question: `How Many LoL Accounts Can I Purchase?`,
      answer: `Currently, you can only purchase 1 LoL account at a time due to security reasons. However, if you’re looking to buy accounts in bulk then please <a href="https://www.unrankedsmurfs.com/help">contact us</a> for more details.`,
    },
    {
      question: `Can I Play Ranked Matches Straight Away?`,
      answer: `At Unranked Smurfs, we have different kinds of accounts. Most of our accounts come with 20 champs or more, allowing you to play ranked instantly. However, some accounts come with less than 20 champs, which is noted in the package description.`,
    },
    {
      question: `What’s The Difference Between BE Accounts and Special Accounts?`,
      answer: `Our BE accounts (EUW - 50K BE) have a set amount of BE and RP on them but no champions or runes unlocked. Special accounts come with the number of champions stated but don’t come with any set amount of BE & RP.`,
    },
    {
      question: `What Champions Come With Special Accounts?`,
      answer: `Our special LoL accounts come with a range of champions as stated in their description. These champions are completely random and can range from 450 to 6300 BE.`,
    },
    {
      question: `Can I Pick My Summoner Name?`,
      answer: `All of our League of Legends smurf accounts come with randomly generated natural names. However, if for whatever reason you don’t like your summoner name you can always change it using the included BE or RP.`,
    },
    {
      question: `How Are Your LoL Accounts Leveled?`,
      answer: `We only sell League accounts that are hand leveled by real players ensuring each account has a minimum win rate of 45% across a variety of different games modes. By doing this we can ensure that none of our accounts gets banned for botting meaning we only offer the highest quality smurf accounts.`,
    },
    {
      question: `Are You The Only Site To Offer Lifetime Warranties?`,
      answer: `Lots of other smurf account sellers claim to offer warranties but when it comes toproviding the replacement account, many sellers will back out and offer excuses. Having been in business for several years, it's incredibly important to us to offer this warranty. Currently, we are the only LoL account store that always honors this promise.`,
    },
    {
      question: `I Got Banned For Botting (Bot Account Buying) Can I Get A New Account?`,
      answer: `Yes! If your League of Legends account got banned for botting or account sharing then <a href="https://www.unrankedsmurfs.com/help">contact us</a> and we’ll be able to sort out your replacement account.`,
    },
    {
      question: `I Got Banned For Flaming/Feeding/Hacking Can I Get A New Account?`,
      answer: `No! If your account got banned for anything that was your fault, e.g. flaming, feeding, hacking or cheating, then we won’t be able to replace your account. As stated in our terms and conditions, we only replace accounts that have been banned due to our fault.`,
    },
    {
      question: `Do You Offer Any Discounts?`,
      answer: `If you’re looking for a sale, League accounts on this site can be purchased with a discount code. You can scroll up to the top of this page to see the latest coupon code. Sometimes we offer accounts with a discount to our customers and fans who follow us on social media or subscribe to our mailing list. To get further discounts be sure to follow us on <a href="https://twitter.com/unrankedsmurfs">Twitter</a>, <a href="https://www.facebook.com/UnrankedSmurfs/">Facebook</a>.`,
    },
    {
      question: `Can I Have Some Free RP?`,
      answer: `Yes! By entering our awesome RP <a href="https://www.unrankedsmurfs.com/lol-giveaway">giveaway competition</a> you have the chance to win free RP and LoL merch. To keep up to date with our giveaways be sure to sign up to our mailing list.`,
    },
    {
      question: `Can I Pay In Another Currency?`,
      answer: `Although our prices are listed in USD you can buy accounts in your local currency. Your payment method will automatically convert your local currency to USD to make a purchase.`,
    },
  ],
  'ranked-Diamond': [
    {
      question: `Will I Lose My Rank If I Don’t Play?`,
      answer: `Diamond accounts and above, players will demote if they don't play at least one game every 28 days. You can check when you will demote by going into ranked tab in League client.`,
    },
    {
      question: `How Many Champions Does The Account Come With?`,
      answer: `Each ranked Diamond account comes with a minimum of 20 champions, enough to play ranked.`,
    },
    {
      question: `Does The Account Come With Any Skins?`,
      answer: `We can’t guarantee any skins on these accounts, but you can always claim the free in-game skins.`,
    },
    {
      question: `What Rank Will My Account Be?`,
      answer: `Diamond ranked accounts will have at least a ranking of Diamond IV or higher.`,
    },
    {
      question: `What Happens If My Account Gets Banned?`,
      answer: `In the unlikely event that your account gets banned for account sharing, we’ll issue a replacement account of the same rank or higher.`,
    },
  ],
  'ranked-Platinum': [
    {
      question: `Will I Lose My Rank If I Don’t Play?`,
      answer: `With Platinum accounts and below, players will not lose their rankings if they are inactive.`,
    },
    {
      question: `How Many Champions Does The Account Come With?`,
      answer: `Each ranked Platinum account comes with a minimum of 20 champions, enough to play ranked.`,
    },
    {
      question: `Does The Account Come With Any Skins?`,
      answer: `We can’t guarantee any rare skins on these Platinum accounts, but you can always claim the free in-game skins.`,
    },
    {
      question: `What Rank Will My Account Be?`,
      answer: `Platinum ranked accounts will have at least a ranking of Platinum IV or higher.`,
    },
    {
      question: `What Happens If My Account Gets Banned?`,
      answer: `In the unlikely event that your account gets banned for account sharing, we’ll issue a replacement account of Platinum IV or higher.`,
    },
  ],
  'ranked-Gold': [
    {
      question: `Will I Lose My Rank If I Don’t Play?`,
      answer: `With Gold ranked accounts and below, players will not lose their rankings if they are inactive throughout the season.`,
    },
    {
      question: `How Many Champions Does The Account Come With?`,
      answer: `Each account comes with a minimum of 20 champions, enough to play ranked matches.`,
    },
    {
      question: `Does The Account Come With Any Skins?`,
      answer: `We can’t guarantee any rare skins on these Gold accounts, but you can always claim the free in-game skins.`,
    },
    {
      question: `What Rank Will My Account Be?`,
      answer: `Gold ranked accounts will have at least a ranking of Gold IV or higher.`,
    },
    {
      question: `What Happens If My Account Gets Banned?`,
      answer: `In the unlikely event that your account gets banned for account sharing, we’ll issue a replacement account of Gold IV or higher.`,
    },
  ],
  'ranked-Silver': [
    {
      question: `Will I Lose My Rank If I Don’t Play?`,
      answer: `With Silver ranked accounts and below, players will not lose their ranking if they don’t play.`,
    },
    {
      question: `How Many Champions Does The Account Come With?`,
      answer: `Each account comes with a minimum of 20 champions, enough to play ranked.`,
    },
    {
      question: `Does The Account Come With Any Skins?`,
      answer: `We can’t guarantee any skins on these accounts, but you can always claim the free in-game skins.`,
    },
    {
      question: `What Rank Will My Account Be?`,
      answer: `Silver ranked accounts will have at least a ranking of Silver IV or higher.`,
    },
    {
      question: `What Happens If My Account Gets Banned?`,
      answer: `In the unlikely event that your account gets banned, we’ll issue a replacement account of the same rank or higher.`,
    },
  ],
  'ranked-Bronze': [
    {
      question: `Will I Lose My Rank If I Don’t Play?`,
      answer: `Bronze accounts can't lose their rank even if you don't play any games.`,
    },
    {
      question: `How Many Champions Does The Account Come With?`,
      answer: `Each account comes with a minimum of 20 champions, enough to play ranked. Some accounts can have more.`,
    },
    {
      question: `Does The Account Come With Any Skins?`,
      answer: `We can’t guarantee any skins on these accounts, but you can always claim the free in-game skins.`,
    },
    {
      question: `What Rank Will My Account Be?`,
      answer: `Bronze ranked accounts will have at least a ranking of Bronze IV or higher.`,
    },
    {
      question: `What Happens If My Account Gets Banned?`,
      answer: `In the unlikely event that your account gets banned, we’ll issue a replacement account of the same rank or higher.`,
    },
  ],
  partners: [
    {
      question: 'What do I get from applying?',
      answer:
        'If you’re successful in your affiliate application, then you’ll become a registered UnrankedSmurfs.com affiliate. This means you’ll receive a unique link that you’ll be able to give to your viewers and readers. You can also give out discount codes from our website which will give customers 10% off all purchases as well as giving you 20% commission as well! For larger streamers with hundreds of viewers, we’ll even give you a free unranked League of Legends smurf account for you to play on your stream. If you think you have plenty of viewers on your stream and want to form a partnership, contact us below.',
    },
    {
      question: 'How does the scheme work?',
      answer:
        'Every time someone purchases an account from our store using your coupon. You’ll instantly receive 20% commission of the total sale price. No matter if you sell an account for $30 or $200, you’ll always receive 20%. Payments will be sent at the end of every month with no minimum payment. That means even if you only make 1 sale in a 30-day period, you’ll still receive your commission at the end of the month via PayPal.',
    },
    {
      question: 'Do I need to be big?',
      answer:
        'Not at all! Although having a larger audience increases your chances of making a sale, anyone can apply. No matter if you have 5 regular Twitch streamers or over 1000, anyone can sign up for the UnrankedSmurf affiliate scheme.',
    },
    {
      question: 'Regional Availability',
      answer:
        'Before signing up to our affiliate scheme, you’ll probably want to make sure we sell accounts in your region. If the majority of your audience is from Russia, then they’ll most likely want to buy Russian accounts. Here at UnrankedSmurfs we currently sell accounts from over 9 different regions. That’s more than any other LoL smurf seller out there! To see which regions we have available, be sure to have a look on our homepage.',
    },
    {
      question: 'Who can apply?',
      answer:
        'Anyone can apply to the UnrankedSmufs affiliate scheme no matter how old you are. Like we mentioned before, you’ll need to have a PayPal account in order to receive payments. Apart from that, there are no other restrictions.',
    },
  ],
};

export default {
  components: {
    'faq-section': FaqSection,
  },

  props: {
    questionType: {
      type: String,
      default: 'default',
    },
  },

  data() {
    return {
      questions: QUESTIONS[this.questionType],
    };
  },
};
</script>

<style lang="scss">
$duration: 0.25s;

.us-faq {
  .faq-section {
    .faq-section__content {
      .faq-section-item {
        border: 1px solid #494949;
        background: #181818;
        margin-bottom: 16px;

        &__question {
          @apply p-4;
          @apply text-honestly-white;
          transition: $duration all;
          background: #181818;

          &--open,
          &:hover {
            @apply text-smurfs-gold;
          }
        }

        &__answer {
          @apply px-4;
          @apply ml-4;
          background: #181818;

          &--open {
            @apply pb-4;
          }
        }
      }
    }
  }
}
</style>
